






















import { Component, Vue } from 'vue-property-decorator'
import { PreviewRefundPostProcessCorrection, ApplyRefundPostProcessCorrection } from '@/api'
import { OrderStatusFormat } from '@/utils/tyepconvert'
import { Message, MessageBox } from 'element-ui'

@Component
export default class RefundPostProcessCorrectionDialog extends Vue {
  private visible = false
  private loading = false
  private submitting = false
  private preview: any = null

  public async open(orderCode: string) {
    this.visible = true
    this.preview = null
    this.loading = true
    try {
      this.preview = await PreviewRefundPostProcessCorrection({ orderCode })
      if (!this.preview.correctable) {
        Message.warning(this.preview.abnormalDesc || '当前订单不可补正')
      }
    } finally {
      this.loading = false
    }
  }

  private fenToYuan(fen: number) {
    if (fen == null) {
      return '0.00'
    }
    return (fen / 100).toFixed(2)
  }

  private statusLabel(code: number) {
    return code != null ? OrderStatusFormat(code) : '-'
  }

  private async confirmHandle() {
    if (!this.preview || !this.preview.correctable) {
      return
    }
    try {
      await MessageBox.confirm(
        '确认执行补正？此操作不会再次退款，将更正订单状态并扣减店铺待结算（如需要）。',
        '确认补正',
        { type: 'warning' }
      )
    } catch {
      return
    }
    this.submitting = true
    try {
      const res = await ApplyRefundPostProcessCorrection({ orderCode: this.preview.orderCode })
      Message.success((res && res.message) || '补正成功')
      this.visible = false
      this.$emit('done')
    } finally {
      this.submitting = false
    }
  }

  private onClose() {
    this.preview = null
  }
}
